import DOMPurify from "dompurify";

const CONFIG = {
  ALLOWED_TAGS: [
    "p", "br", "b", "strong", "i", "em", "u", "s", "a", "ul", "ol", "li",
    "h1", "h2", "h3", "h4", "blockquote", "code", "pre", "img", "span", "div", "hr",
  ],
  ALLOWED_ATTR: ["href", "src", "alt", "title", "target", "rel", "class", "style"],
  ALLOW_DATA_ATTR: false,
};

// Only these CSS properties survive inline styles (blocks layout/defacement abuse like position:fixed).
const ALLOWED_CSS = new Set([
  "font-size", "font-weight", "font-style", "text-align",
  "color", "text-decoration", "line-height",
]);

if (typeof window !== "undefined" && DOMPurify.addHook) {
  DOMPurify.addHook("afterSanitizeAttributes", (node) => {
    // Force safe behaviour on external links only.
    if (node.tagName === "A") {
      const href = node.getAttribute("href") || "";
      if (/^https?:\/\//i.test(href)) {
        node.setAttribute("target", "_blank");
        node.setAttribute("rel", "noopener noreferrer");
      }
    }
    // Whitelist inline CSS properties.
    if (node.hasAttribute && node.hasAttribute("style") && node.style) {
      const kept = [];
      for (let i = 0; i < node.style.length; i++) {
        const prop = node.style[i];
        if (ALLOWED_CSS.has(prop)) kept.push(`${prop}: ${node.style.getPropertyValue(prop)}`);
      }
      if (kept.length) node.setAttribute("style", kept.join("; "));
      else node.removeAttribute("style");
    }
  });
}

export function sanitizeHtml(dirty) {
  if (dirty == null) return "";
  return DOMPurify.sanitize(String(dirty), CONFIG);
}
